import { Injectable } from '@angular/core';
import { ColDef, ColGroupDef } from 'ag-grid-enterprise';

@Injectable({
    providedIn: 'root',
})

export class HhraRunRiskAssessmentUSHandlerResultsColDef {

    public getColumnsDefinition(isProjectOwnershipValid: boolean): (ColDef | ColGroupDef)[] | null {
        return [
            {
                headerName: '',
                children: [
                    {
                        headerName: 'Compound',
                        field: 'Compound',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        pinned: 'left'
                    },
                    {
                        headerName: 'Endpoint Dataset',
                        field: 'EndpointDataSet',
                        width: 200,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        pinned: 'left'
                    },
                    {
                        headerName: 'Exposure Scheme',
                        field: 'ExposureScheme',
                        width: 200,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        pinned: 'left'
                    },
                    {
                        headerName: 'Exposure Duration',
                        field: 'ExposureDuration',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        pinned: 'left'
                    }
                ]
            },
            {
                headerName: 'Dermal - Non-cancer',
                children: [
                    {
                        headerName: 'POD (mg/kg/day)',
                        field: 'DermalPOD',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'POD source/study',
                        field: 'DermalPODSource',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'LOC',
                        field: 'DermalLOC',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Body weight (kg)',
                        field: 'DermalBodyWeight',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }
                ]
            },
            {
                headerName: 'Dermal - Absorption',
                children: [
                    {
                        headerName: 'Fraction',
                        field: 'DermalFraction',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Absorption source/study ',
                        field: 'DermalAbsorptionSource',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }
                ]
            },
            {
                headerName: 'Inhalation - Non-cancer',
                children: [
                    {
                        headerName: 'POD (mg/kg/day)',
                        field: 'InhalationPOD',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'POD source/study',
                        field: 'InhalationPODSource',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'LOC',
                        field: 'InhalationLOC',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Body weight (kg)',
                        field: 'InhalationBodyWeight',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }
                ]
            },
            {
                headerName: 'Inhalation - Absorption',
                children: [
                    {
                        headerName: 'Fraction',
                        field: 'InhalationFraction',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Absorption source/study ',
                        field: 'InhalationAbsorptionSource',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }
                ]
            },
            {
                headerName: 'Exposure Scheme',
                children: [
                    {
                        headerName: 'Worker activity',
                        field: 'WorkerActivity',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Formulation',
                        field: 'Formulation',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Application equipment',
                        field: 'ApplicationEquipment',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Application type',
                        field: 'ApplicationType',
                        width: 155,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Crop/target category',
                        field: 'CropOrTarget',
                        width: 300,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Application Rate',
                        field: 'MaximumApplicationRate',
                        width: 150,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Application Rate Unit',
                        field: 'ApplicationRateUnit',
                        width: 150,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Level of PPE - Dermal',
                        field: 'DermalPPEOrEngineeringControl',
                        width: 270,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Level of PPE - Inhalation',
                        field: 'InhalationPPEOrEngineeringControl',
                        width: 270,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }
                ]
            },
            {
                headerName: 'Results',
                children: [
                    {
                        headerName: 'Amount handled/area treated',
                        field: 'AreaTreatedDaily',
                        width: 170,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Dermal Dose',
                        field: 'DermalDose',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Dermal MOE',
                        field: 'DermalMOE',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Dermal Result',
                        field: 'DermalResult',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        cellStyle: params => {
                            if (params.value === 'Fail') {
                                return { color: 'red', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            if (params.value === 'Pass') {
                                return { color: 'green', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            return null;
                        }
                    },
                    {
                        headerName: 'Inhalation Dose',
                        field: 'InhalationDose',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Inhalation MOE',
                        field: 'InhalationMOE',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'Inhalation Result',
                        field: 'InhalationResult',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        cellStyle: params => {
                            if (params.value === 'Fail') {
                                return { color: 'red', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            if (params.value === 'Pass') {
                                return { color: 'green', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            return null;
                        }
                    },
                    {
                        headerName: 'Combined MOE',
                        field: 'TotalMOE',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'ARI',
                        field: 'TotalARI',
                        width: 120,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                    },
                    {
                        headerName: 'ARI Result',
                        field: 'TotalAriResult',
                        width: 130,
                        filter: 'agSetColumnFilter',
                        editable: false,
                        resizable: true,
                        sortable: true,
                        cellStyle: params => {
                            if (params.value === 'Fail') {
                                return { color: 'red', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            if (params.value === 'Pass') {
                                return { color: 'green', fontWeight: 'bold', backgroundColor: isProjectOwnershipValid ? 'unset' : '#f0f0f0' };
                            }
                            return null;
                        }
                    },
                ]
            }
        ];
    }
}